var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (typeof message === 'string') {
            message = Logger.prefix(message, 'Info');
        }
        console.info(message, Logger.prefixStyle('#2096ff'), '');
    };
    Logger.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (typeof message === 'string') {
            message = Logger.prefix(message, 'Warning');
        }
        console.warn(message, Logger.prefixStyle('#ff7c0d'), '');
    };
    Logger.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (typeof message === 'string') {
            message = Logger.prefix(message, 'Error');
        }
        else if (message instanceof Error) {
            message.message = Logger.prefix(message.message, 'Error');
        }
        console.error(message, Logger.prefixStyle('#FF0000'), '');
    };
    Logger.prefix = function (message, prefix) {
        var date = new Date();
        return '%c' + prefix + ' - ' +
            date.toLocaleDateString("en-US") + " " +
            date.toLocaleTimeString("en-US") + " %c" + message;
    };
    Logger.prefixStyle = function (color) {
        return 'background: ' + color +
            '; color: #FFFFFF;border-radius:3px;border:1px solid ' + color +
            ';padding:4px 6px; font-size:10px;margin-right:4px;';
    };
    return Logger;
}());
var logger = new Logger();
export { Logger, logger };
//# sourceMappingURL=logger.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/logger.js
// module id = 976
// module chunks = 14